module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1032-d391b215b9ee8aa9540e41e66321980f.png";